/**
 * How far a node has to move before it counts as having moved.
 *
 * Sub-pixel: the arithmetic is floating point, so re-running a layout on a document it already
 * arranged produces values that differ in the last bits. Treating those as changes is not a
 * rounding annoyance — it is an infinite loop, because a layout that always reports changes is a
 * layout the auto-arrange dispatches, which triggers a layout.
 */
const MOVED_EPSILON = 0.5;
/**
 * Drops placements that put a node where it already is.
 *
 * This is what makes the layout idempotent, and idempotence is what makes it safe to run after
 * every edit: the second run reports nothing, so nothing is dispatched, so nothing triggers a
 * third. It also keeps the journal honest — an `apply-layout` naming ten thousand unchanged
 * coordinates is an edit that did not happen.
 */
export function onlyMoves(document, placements) {
    const moved = {};
    for (const [id, placement] of Object.entries(placements)) {
        const node = document.nodes[id];
        if (node === undefined)
            continue;
        if (Math.abs(node.x - placement.x) < MOVED_EPSILON &&
            Math.abs(node.y - placement.y) < MOVED_EPSILON) {
            continue;
        }
        moved[id] = placement;
    }
    return moved;
}
//# sourceMappingURL=moves.js.map